import * as React from "react";

function SvgZeta(props, ref) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 64 64" {...{ ...props, ref }}>
      <defs>
        <linearGradient
          x1="100%"
          y1="50%"
          x2="0%"
          y2="50%"
          id="linearGradient-1"
        >
          <stop stopColor="#0A05B0" offset="39.87%"></stop>
          <stop stopColor="#0068D0" offset="100%"></stop>
        </linearGradient>
        <linearGradient
          x1="1.73552105e-14%"
          y1="50%"
          x2="100%"
          y2="50%"
          id="linearGradient-2"
        >
          <stop stopColor="#00C2FF" offset="0%"></stop>
          <stop stopColor="#BC2676" offset="53.98%"></stop>
          <stop stopColor="#FFFB6A" offset="85.68%"></stop>
        </linearGradient>
      </defs>
      <g
        id="Login-Flow"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Login-1.0"
          transform="translate(-135.000000, -136.000000)"
          fillRule="nonzero"
        >
          <g
            id="2---Navigation/1-Top-Bar/Logos/1-Zeta-Logo"
            transform="translate(135.000000, 136.000000)"
          >
            <polygon
              id="Path"
              fill="url(#linearGradient-1)"
              points="27.311106 49.2343523 25.59255 41.3624454 13.9806852 32 0 32 21.5980685 49.3740902 24.7100483 64 60.6139342 32 46.633249 32"
            ></polygon>
            <polygon
              id="Path"
              fill="url(#linearGradient-2)"
              points="33.3028282 14.7656477 34.9749368 22.6375546 46.633249 32 60.6139342 32 39.0158657 14.6259098 35.8574385 0 0 32 13.9806852 32"
            ></polygon>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgZeta);
